<script>
/**
 * @file 课程详情
 */
import Footer from './footer.vue';
import {classesList} from '../__mock__/classes';
import mixin from './mixins_api';

export default {
    mixins: [mixin],
    components: {
        Footer
    },
    methods: {
        goback() {
            this.$router.push({
                name: this.$route.params.refer_name,
                params: {
                    id: this.$route.params.classId
                }
            });
        }
    },
    created() {
        let id = this.$route.params.id;
        this.getTeacherDetail(id).then(res => {
            let result = res.result || {};
            this.teacherInfo = {...result};
        })
    },
    data() {
        return {
            teacherInfo: {}
        };
    }
}
</script>

<template lang="pug">
.forkiss-author-detail-container
    .author-detail-header-bg
    .back-btn(@click="goback", data-touch="true")
    .author-wrapper
        .author-img(:style="`background-image: url(${teacherInfo.pic})`")
        .name-box
            .name {{teacherInfo.name}}
            .en-name {{teacherInfo.name_en}}
        ul.overview-list(v-if="teacherInfo.honour && teacherInfo.honour.length > 0")
            li(v-for="item in teacherInfo.honour") {{item}}
            //- li FORKISS 孕期教学总监
            //- li Baby Center 特邀专家
            //- li 国内唯一五星级孕产导师
            //- li 三次蝉联孕妇瑜伽十街吉尼斯纪录 首席导师
            //- li 中国区唯一孕期分娩培训师
            //- li 职业分娩乐师，泌乳指导师
        .more-detail-box(v-html="teacherInfo.content")
            //- p 建慧老师截止2016年已记录在册累计了上万节课的孕期瑜伽课时，服务了仅3000位的孕妈妈。累计陪产时间超1000小时。或许,是因为自身已经是两位孩子的母亲,及其注册分娩导乐师的身份,令她拥有丰富的孕期知识和陪产经验,她带领团队研发的孕期课程,得到了上千位孕妇的肯定,而且开创了孕期课程新的思路和理念。中英文授课。
            //- .img-box
            //-     .img1
            //-     .img2
            //- p 建慧老师受邀成为《妈咪宝贝》《时尚健康》《爱家广播》《父母必读》《辣妈学院》等主流母婴媒体的座上嘉宾,在媒体平台上与更多的孕妈妈分享孕产专业知识。同时她也是戴霍思燕、刘璇、申雪、沈佳妮、代乐乐、濮方、戴娆、大萌子等众多明星的私人孕期老师与分娩导乐师。
</template>

<style lang="less" scoped>
.forkiss-author-detail-container {
    position: relative;
    background: #b88e64; // 背景图占位
    padding: 1.54rem .3rem .72rem;
    font-size: .24rem;
    height: 100%;
    overflow: auto;

    .author-detail-header-bg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
        width: 100%;
        height: 6.66rem;
        background-image: url(../assets/author-bg.png);
        background-size: cover;
        background-position: center;
    }
    .back-btn {
        position: absolute;
        z-index: 22;
        top: .2rem;
        left: .2rem;
        width: .44rem;
        height: .44rem;
        background-image: url(../assets/back.svg);
        background-size: contain;
    }

    .author-wrapper {
        position: relative;
        z-index: 9;
        padding: 1.1rem .72rem .66rem;
        background: rgba(255, 255, 255, .7);
        border-radius: .1rem;
        min-height: 100%;

        .author-img {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 1.98rem;
            height: 1.98rem;
            border-radius: 50%;
            border: .06rem solid #edd3b7;
            border-radius: 50%;
            background: #f8ede1;
            background-image: url(../assets/detail-avatar.png);
            background-size: contain;
            background-repeat: no-repeat;
        }
        .name-box {
            text-align: center;
            color: #a4805b;

            .name {
                font-size: .4rem;
                font-weight: 600;
            }
        }

        .overview-list {
            padding: 0 0 0 .4rem;
            color: #a4805b;
            line-height: 1.8;
        }
        .more-detail-box {
            line-height: 1.8;
            color: #666;
            p {
                text-indent: .48rem;
            }

            .img-box {
                .img1 {
                    display: inline-block;
                    width: 3.34rem;
                    height: 2.15rem;
                    margin-right: .2rem;
                    background-position: center;
                    background-size: cover;
                    background-image: url(../assets/author-detail-img1.png);
                }
                .img2 {
                    display: inline-block;
                    width: 1.82rem;
                    height: 2.15rem;
                    background-position: center;
                    background-size: cover;
                    background-image: url(../assets/author-detail-img2.png);
                }
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/author-detail.vue